import { memo } from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import { CheckCircle2 } from "lucide-react";

const EMIBreakdown = memo(({ emiData, sx }) => {
  if (!emiData) return null;

  const emiItems = [
    {
      label: "Monthly EMI",
      value: `₹${emiData.monthly?.toLocaleString("en-IN") || 0}`,
    },
    {
      label: "Daily EMI",
      value: `₹${emiData.daily?.toLocaleString("en-IN") || 0}`,
    },
    {
      label: "Weekly EMI",
      value: `₹${emiData.weekly?.toLocaleString("en-IN") || 0}`,
    },
  ];

  return (
    <Card
      sx={{
        mb: 3,
        backgroundColor: "#f0fdf4",
        border: "1px solid #d1fae5",
        ...sx,
      }}
    >
      <CardContent>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
            color: "#059669",
            mb: 2,
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CheckCircle2 style={{ fontSize: "20px", color: "#059669" }} />
          EMI Breakdown
        </Typography>

        <Grid container spacing={2}>
          {emiItems.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.label}>
              <Box
                sx={{
                  p: 1.5,
                  backgroundColor: "white",
                  borderRadius: "8px",
                  border: "1px solid #d1fae5",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    color: "#6b7280",
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 700,
                    color: "#059669",
                    fontSize: "18px",
                  }}
                >
                  {item.value}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
});

export default EMIBreakdown;
